import request from '@/utils/request'
import { setToken, removeToken } from '@/utils/auth'

// 山东统一认证服务平台 查询登录状态
export function getlogin(uuid) {
  return request({
    url: '/web/sdtyfzfw/login/' + uuid,
    method: 'get'
  }).then(res => {
    // SSO 登录成功后，把后端签发的 RuoYi JWT 写入 cookie，后续请求自动携带 Authorization
    // 统一放在这里，确保 indexJump.vue / Index.vue 等所有登录入口都能写入 token
    if (res && res.data && res.data.ruoYiToken) {
      setToken(res.data.ruoYiToken)
    }
    return res
  })
}
// 山东统一认证服务平台 获取用户登录信息
//----需要修改为recid【】
export function getLoginUser(recid) {
  return request({
    url: '/web/sdtyfzfw/getLoginUser/' + recid,
    method: 'get'
  })
}

//----需要修改为recid【】
export function getLogout(recid) {
  return request({
    url: '/web/sdtyfzfw/getLogout/' + recid,
    method: 'get'
  }).then(res => {
    // 退出登录时同步清除本地 JWT cookie
    removeToken()
    return res
  })
}

//验证uuid是否可以解密，验证是否过期
export function checkUuidValidDate(uuid){
  return request({
    url: '/web/sdtyfzfw/checkUuidValidDate/' + uuid,
    method: 'get'
  })
}

